// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"09918a49","305":"75be777c","311":"4b6612bd","379":"82fe72ea","482":"69759085","545":"712124a2","787":"c6fd372b","921":"312f5249","975":"ae9892d2","997":"c9968cbd"}[chunkId] + ".chunk.js";
};